import { Navigate } from "react-router-dom"
import { route, routes } from "~/helpers/routeHelper"
import { useAuth } from "~/context/auth"
import { TAuthmiddleware } from "~/types/global"

const Authmiddleware = ({
  component,
  componentProps,
  layout,
  isProtected,
  isStrict,
}: TAuthmiddleware) => {

  const { isLoggedIn } = useAuth();

  const Component = component as unknown as React.ComponentType<any>;
  const Layout = layout as unknown as React.ComponentType<any>;

  if (isProtected && !isLoggedIn()) {
    // this route is protected and the user is not logged in
    // so redirect to login
    return <Navigate to={route(routes.login, null, { ret: encodeURIComponent(window.location.href) })} />
  } else if (!isProtected && isLoggedIn() && isStrict) {
    // this route is public and the user is logged in
    // so redirect to homepage
    return <Navigate to={route(routes.home)} />
  }
  return <Layout>
    <Component {...componentProps} />
  </Layout>
}

export default Authmiddleware;
